import React, { useState } from 'react'
import './Contactus.css'
import Footer from './Footer'
import Navbar from './Navbar'
import Whatsapp from './Whatsapp'
import FormCaptchaField, {
  getFormField,
  submitToGoogleScript,
  useFormCaptcha,
} from './FormCaptcha'
import {
  CONTACT_FORM_URL,
  CONTACT_SUCCESS_MESSAGE,
  buildContactFormPayload,
  isFormScriptError,
} from '../config/formScripts'

const CONTACT_REASONS = [
  { title: 'Join the Chapter', text: 'Ready to become a member of the LITAA North America Chapter? Reach out and we will walk you through annual or life membership options and get you connected to the community.' },
  { title: 'Support a Project', text: 'Interested in contributing to the library, a gold medal, a classroom, a scholarship, or the washroom renovation project? We will be happy to provide full details, answer your questions, and guide you through the giving process. All contributions through the NA Chapter are tax-deductible for US donors (EIN: 39-2341136).' },
  { title: 'Attend the Retreat', text: 'Planning to join us for the Inaugural Alumni Weekend Retreat, September 11–13, 2026? RSVP via the Google Form on our Events page. Venue: 16260 Kensington Dr Suite B, Sugar Land, TX 77478. Formal invitation in August; RSVP deadline August 15.' },
  { title: 'Volunteer or Serve', text: 'Interested in joining a committee, helping organize events, or taking on a leadership role as the chapter grows? We welcome your energy and expertise.' },
  { title: 'General Inquiries', text: 'Questions about the chapter, LITAA membership, or anything else? Drop us a line and we will get back to you promptly.' },
];

export default function Contactus() {
  const [thankYouMessage, setThankYouMessage] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [captchaError, setCaptchaError] = useState('');
  const captcha = useFormCaptcha();

  const handleSubmit = (e) => {
    e.preventDefault()
    const form = e.target;
    setSubmitError('');

    if (!captcha.validate()) {
      setCaptchaError('Please answer the security check correctly before submitting.');
      return;
    }
    setCaptchaError('');

    const url = CONTACT_FORM_URL

    setIsSubmitting(true);
    submitToGoogleScript(url, buildContactFormPayload(getFormField, form))
      .then((data) => {
        if (isFormScriptError(data)) {
          setSubmitError(data);
          return;
        }
        setThankYouMessage(CONTACT_SUCCESS_MESSAGE);
        setTimeout(() => setThankYouMessage(''), 5000);
        form.reset();
        captcha.reset();
      })
      .catch((error) => {
        setSubmitError('Something went wrong. Please try again or email us directly.');
        console.error(error);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  }

  return (
    <div className="main-wrapper page">
      <Navbar />
      <section className="contact_us" data-aos="fade-up" data-aos-duration="1000">
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="contact_inner">
                <div className="row">
                  <div className="col-md-10">
                    <div className="contact_form_inner">
                      <div className="contact_field">
                        <h3>Get in Touch</h3>
                        <p>
                          Whether you want to join, give, volunteer, or simply reconnect — we want to hear from you.
                        </p>
                        {thankYouMessage && (
                          <div style={{ color: 'black', textAlign: 'center', marginBottom: '10px' }}>
                            {thankYouMessage}
                          </div>
                        )}
                        {submitError && (
                          <p className="form-captcha-error" role="alert">{submitError}</p>
                        )}
                        <form onSubmit={handleSubmit}>
                          <input
                            type="text"
                            className="form-control form-group"
                            name="name"
                            required
                            placeholder="Full Name"
                          />
                          <input
                            type="email"
                            className="form-control form-group"
                            required
                            name="email"
                            placeholder="Email Address"
                          />
                          <input
                            type="text"
                            className="form-control form-group"
                            name="graduationYear"
                            placeholder="Graduation Year (optional)"
                          />
                          <input
                            type="text"
                            className="form-control form-group"
                            name="discipline"
                            placeholder="Discipline / Program (optional)"
                          />
                          <select
                            className="form-control form-group"
                            name="reason"
                            defaultValue=""
                          >
                            <option value="" disabled>Reason for contact</option>
                            <option value="Join the chapter">Join the chapter</option>
                            <option value="Support a project">Support a project</option>
                            <option value="Attend the retreat">Attend the retreat</option>
                            <option value="General inquiry">General inquiry</option>
                            <option value="Other">Other</option>
                          </select>
                          <textarea
                            className="form-control form-group"
                            required
                            name="query"
                            placeholder="Message"
                          />
                          <FormCaptchaField
                            useRecaptcha={captcha.useRecaptcha}
                            mathChallenge={captcha.mathChallenge}
                            mathInput={captcha.mathInput}
                            onMathInputChange={(value) => {
                              captcha.setMathInput(value);
                              if (captchaError) {
                                setCaptchaError('');
                              }
                            }}
                            onRecaptchaChange={captcha.setRecaptchaToken}
                          />
                          {captchaError && (
                            <p className="form-captcha-error" role="alert">{captchaError}</p>
                          )}
                          <button
                            type="submit"
                            className="contact_form_submit"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Sending...' : 'Send Message'}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="right_conatct_social_icon d-flex align-items-end">
                      {/* WhatsApp link hidden until group invite URL is available
                      <div style={{ paddingTop: "10px" }} className="socil_item_inner d-flex">
                        <li>
                          <a href="#">
                            <i className="fa fa-whatsapp" /> Whatsapp
                          </a>
                        </li>
                      </div>
                      */}
                    </div>
                  </div>
                </div>
                <div className="contact_info_sec">
                  <h4>Contact Info</h4>
                  {/* Old: +1 99999999, info@litaana.com */}
                  <div className="d-flex info_single align-items-center">
                    {/* <i className="fa fa-envelope-o" />
                    <span><a href="mailto:globallitalumni@gmail.com">globallitalumni@gmail.com</a></span> */}
                  </div>
                  <div className="d-flex info_single align-items-center">
                    {/* <i className="fa fa-globe" />
                    <span><a href="https://www.litalumni.org" target="_blank" rel="noopener noreferrer">www.litalumni.org</a></span> */}
                  </div>
                  <div className="d-flex info_single align-items-center">
                    <i className="fa fa-address-card" />
                    <span>LIT Alumni Association North America Chapter, 11104 W Airport Blvd Ste 213, Stafford, TX 77477, USA</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="contact-reasons" data-aos="fade-up">
        <div className="container">
          <h3>Reasons to Reach Out</h3>
          <div className="contact-reasons__grid">
            {CONTACT_REASONS.map((item) => (
              <div className="contact-reasons__item" key={item.title} data-aos="fade-up">
                <h5>{item.title}</h5>
                <p>{item.text}</p>
              </div>
            ))}
          </div>
          <p style={{ marginTop: '24px' }}>
            To connect with the broader LIT Alumni Association network, visit{' '}
            <a href="https://www.litalumni.org" target="_blank" rel="noopener noreferrer">www.litalumni.org</a>
            {' '}— the official alumni portal for all LITAA members worldwide.
          </p>
        </div>
      </section>

      <section className="map_sec" data-aos="fade-up" data-aos-duration="1000">
        <div style={{ paddingLeft: "200px", paddingBottom: "100px" }} className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="map_inner">
                <h4>Find Us on Google Map</h4>
                <p>
                  LIT Alumni Association North America Chapter — Stafford, Texas
                </p>
                {/* Old map: Washington, USA
                <iframe src="https://www.google.com/maps/embed?pb=...Washington..." />
                */}
                <div className="map_bind">
                  <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3465.5!2d-95.5577!3d29.6161!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640c1c8c8c8c8c9%3A0x0!2s11104%20W%20Airport%20Blvd%2C%20Stafford%2C%20TX%2077477!5e0!3m2!1sen!2sus!4v1"
                    width="100%"
                    height={450}
                    frameBorder={0}
                    style={{ border: 0 }}
                    allowFullScreen=""
                    aria-hidden="false"
                    tabIndex={0}
                    title="LITAA NA Chapter — Stafford, TX"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Whatsapp />
        <Footer />
      </section>
    </div>
  )
}

























